import qs from 'qs';
import { useQuery } from 'react-query';

import { axios } from 'lib';

const getRelatedUsers = async (companyID, queryStringParams) => {
  const queryString = qs.stringify({ ...queryStringParams });

  const {
    data: { data: users, total },
  } = await axios.get(`/api/companies/${companyID}/users?${queryString}`);

  return { users, total };
};

export const searchCompanyUsers = async (companyID, search, limit = 15) => {
  const queryStringParams = {
    limit,
    search,
    includeinactive: false,
  };
  const { users } = await getRelatedUsers(companyID, queryStringParams);
  return { data: users };
}

const defaultQueryParams = {
  page: 0,
  limit: 10,
  search: '',
  includeInactive: false,
  status: undefined,
  queryKey: ['companies-related-users'],
  queryOptions: {},
};

export const useGetCompanyUsers = (companyID, queryParams = {}) => {
  const { page, limit, search, includeInactive, status, queryKey, queryOptions } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    limit,
    search,
    includeinactive: includeInactive,
    offset: page * limit,
    ...(status ? { status } : {}),
  };

  return useQuery(
    [...queryKey, companyID],
    () => getRelatedUsers(companyID, queryStringParams),
    {
      select: ({ users, total }) => ({ users, total }),
      initialData: { users: [], total: 0 },
      ...queryOptions,
    }
  );
}